import Pagination from '@mui/material/Pagination';
import { CSSProperties, ChangeEvent, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Select from 'react-select';
import { mockSearchData } from '../../mock';
import './index.scss';

type SearchProps = {
  term: string
}

const Options = [
  { value: 'most_recent1', label: 'Most Recent' },
  { value: 'most_recent2', label: 'Most Recent' },
  { value: 'most_recent3', label: 'Most Recent' },
]

const selectStyles: any = {
  option: (styles: CSSProperties, state: any) => {
    return {
      ...styles,
      backgroundColor: state.isSelected ? '#0080bb' : '#fff'
    };
  },
  control: (styles: CSSProperties, state: any) => ({
    ...styles,
    fontSize: 'var(--font-size-base)',
    width: '150px',
    borderRadius: state.menuIsOpen ? '17.02px 17.02px 0px 0px' : '17.02px',
    borderColor: '#0080bb',
    '&:hover': {
      borderColor: '#969696',
    },
  }),
  menuList: (styles: CSSProperties) => ({
    ...styles,
    fontSize: 'var(--font-size-base)',
  }),
};

const paginationStyles = {
  '& .Mui-selected': {
    bgcolor: '#0080bb !important',
    color: '#fff'
  },
}

const Search: React.FC<SearchProps> = () => {
  const navigate = useNavigate();
  const [pageCount, setPageCount] = useState<number>(1);

  const onPageChange = (_: ChangeEvent<unknown>, page: number) => {
    setPageCount(page)
  };


  return <div className='search'>
    <div className='search__header'>
      <p>Search Result (12)</p>
      <Select styles={selectStyles} options={Options} />
    </div>
    <div className='search__result'>
      {mockSearchData.map((item, idx) => <div className='item' key={idx}>
        <p>{item.title}</p>
        <p>{item.content}</p>
        <p className='a' onClick={() => navigate(`/search/${item.id}`)}>View More</p>
      </div>)}
    </div>
    <div className='search__pagination'>
      <Pagination count={10} onChange={onPageChange} page={pageCount} sx={paginationStyles} />
    </div>
  </div>
}

export default Search